import { useNavigate, useParams } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { FormGroup, Card, PageHeader, Button } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";

import Helmet from "components/helmet/Helmet";

import { Language, usePermission } from "imports/Utils";

import FeetStaffelItemsTable from "./components/tables/FeetStaffelItemsTable";
import { StaffelTabs } from "./utils/StaffelUtils";

import { GetStaffelDocument } from "__generated__/view/staffels/graphql/staffel.queries.generated";

const FeetStaffelDetails = () => {

	const navigate = useNavigate();
	const { id } = useParams();

	const { isAdmin, isMasterdata, isReadOnly } = usePermission();

	const { data, loading } = useQuery(GetStaffelDocument, {
		variables: {
			id: Number(id),
		},
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("FEET")}
					<Helmet title={intl.formatMessage({ id: "FEET" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					<Button onClick={() => navigate(`/view/staffels?tab=${StaffelTabs.FEET}`)} variant="outlined">
						{Language("STAFFELS")}
					</Button>

					{((isAdmin || isMasterdata) && !isReadOnly) && (
						<Button onClick={() => navigate(`/view/staffels/${id}/edit/feet`)}>
							{Language("EDIT")}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Grid spacing={3} container>
				<Grid size={6}>
					<Card>
						<FormGroup label={intl.formatMessage({ id: "DESCRIPTION" })} labelPlacement="left-center" overflow="hidden">
							{data?.staffel?.description}
						</FormGroup>

						<FeetStaffelItemsTable
							content={data?.staffel?.staffelItems ?? []}
							contentLoading={loading} />
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

export default FeetStaffelDetails;
